<hr class="primary-color-background" [ngClass]="(loading$ | async)!">